import SearchResultsPage from '../containers/Search/SearchResultsPage';
import { SEARCH_TAB } from '../components/LeftNav/constants';

export const SearchRoutes = [
	{
		...SearchResultsPage,
		path: '/search',
		tab: SEARCH_TAB,
		exact: true,
		titleId: 'app.document.title.search',
	},
];
